import styled from '@emotion/styled'
import { spacing, colors, radius } from '@mobi/component-library/Foundations'

export const PageContentStyled = styled.div({
  padding: `${spacing.md} 0`,
  background: colors.surface[300],
})

export const IconWrapperStyled = styled.span({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: radius.md,
  filter:
    'drop-shadow(0px 1px 1.5px rgba(26, 14, 35, 0.08)) drop-shadow(0px 1px 3px rgba(26, 14, 35, 0.12))',
  overflow: 'hidden',
  border: '0.2rem solid ' + colors.white,

  ':empty': { display: 'none' },

  '> img': {
    width: '100%',
    height: 'auto',
  },
})
